import React, { useEffect, useRef, useState, useCallback } from "react";
import {
  DataGrid,
  GridColDef,
  GridToolbar,
  GridPaginationModel,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridOverlay,
  GridToolbarQuickFilter,
  GridValueGetter,
} from "@mui/x-data-grid";
import {
  Button,
  Typography,
  Box,
  Grid,
  styled,
  CircularProgress,
  Switch,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import ToastSnackbar, { SnackbarHandle } from "../../common/ToastNotification";
// import ProfileDialogStudentDetailsAdmin from "../../components/ProfileDialogStudentDetailsAdmin";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import HomeIcon from "@mui/icons-material/Home";
import { new_admission_template, students_empty } from "../../Config/students";

import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";

import {
  AddAcademicsRecord,
  AddStudent,
} from "../../api/Students-Management/add-view-students";

import { v4 as uuid } from "uuid";
import { GetExams } from "../../api/Exams-Management/new_exam";
import { deleteFile, uploadFile, UploadFileType } from "../../api/upload";

import {
  DEFAULT_LOGGED_USER,
  // GetCurrentAcademciSession,
} from "../../helper/helper";
import { useApi, useUser } from "../../store/UserLoginContext";
import { getCurrentUser, hasPermission } from "../../service/authService";
// import NewAdmissionDialog from "../../components/NewAdmissionDialog";
import {
  AddApplication,
  ListApplication,
  UpdateApplication,
} from "../../api/Students-Management/new-admission";
import NewAdmissionFormDialog from "../../components/NewAdmissionFormDialog";
import NewStudentAdmissionDialog from "../../components/NewStudentAdmissionDialog";
import AdmissionForm from "../../templates/admissionForm";
import { useReactToPrint } from "react-to-print";
import { CreatePerformaceObj } from "../../helper/helper";

const CustomNoRowsOverlay = ({ loading }: { loading: boolean }) => {
  return (
    <GridOverlay
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <Box sx={{ textAlign: "center", padding: 2 }}>
        {loading ? (
          <>
            <CircularProgress size={40} />
            <Typography variant="h6" color="textSecondary" mt={2}>
              Loading data...
            </Typography>
          </>
        ) : (
          <Typography variant="h5" color="textSecondary">
            NO DATA AVAILABLE
          </Typography>
        )}
      </Box>
    </GridOverlay>
  );
};

// const CustomToolbar: React.FC = () => {
//   return (
//     <GridToolbarContainer>
//       <GridToolbarFilterButton />
//       <GridToolbarExport />
//       <GridToolbarQuickFilter />
//     </GridToolbarContainer>
//   );
// };

// Create buttons with hover underline animation
const AnimatedButton = ({
  label,
  onClick,
  disabled,
}: {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}) => {
  return (
    <Button
      variant="text"
      onClick={onClick}
      sx={{
        position: "relative",
        // fontFamily: "Motiva Sans Bold",
        // fontWeight: "Bold",
        padding: "0 10px",
        fontSize: "14px",
        textTransform: "none",
        color: "#2e186a",
        "&:hover": {
          fontWeight: "Bold",
        },
        "&::after": {
          content: '""',
          fontWeight: "Bold",
          position: "absolute",
          width: "0",
          height: "2px",
          left: "0",
          bottom: "-2px",
          backgroundColor: "rgb(255, 130, 92)",
          transition: "width 0.3s ease-in-out",
        },
        "&:hover::after": {
          width: "100%", // Underline expands on hover
        },
      }}
      disabled={disabled == null ? true : disabled}
    >
      <strong>{label}</strong>
    </Button>
  );
};

const MyCustomButton = styled(Button)(({ theme }) => ({
  fontFamily: "Motiva Sans Bold",
  fontSize: "0.80rem",
  fontWeight: "700",
  border: "1px solid #edf3f5",
  borderRadius: "4px",
  background: "#2e186a",
  boxShadow: "0 16px 30px rgb(23 31 114 / 20%)",
  marginTop: "0rem",
  "&:hover": {
    color: "#fff",
    border: "1px solid rgb(255, 130, 92)",
    backgroundColor: "rgb(255, 130, 92)",
  },
}));

const NewAdmission = () => {
  const { currentSessionAY } = useApi();
  const { user } = useUser();
  const navigate = useNavigate();
  const [applications, setApplications] = useState<any>([]);

  const [isProfileDialogOpen, setProfileDialogOpen] = useState(false);
  const [isProfileDialogAddStudentOpen, setProfileDialogAddStudentOpen] =
    useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isEditingAddStudent, setIsEditingAddStudent] = useState(false);
  const resetFormRef = useRef<() => void>(() => {});
  const resetAddStudentFormRef = useRef<() => void>(() => {});

  const snackbarRef = useRef<SnackbarHandle>(null);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [addNewStudent, setAddNewStudent] = useState<boolean>(false);

  const [classList, setClassList] = useState<any>([]);
  const [sectionList, setSectionList] = useState<any>([]);

  const [loading, setLoading] = useState(true);
  const [adding, setAdding] = useState(false);
  const [printData, setPrintData] = useState<any>();
  const [printStart, setPrintStart] = useState(false);
  // const [fetching, setFetching] = useState(false);
  // const [viewAllStudents, setViewAllStudents] = useState<boolean>(false);
  // const [studentList, setStudentList] = useState<any>([]);
  // const [academiceRecordList, setAcademiceRecordList] = useState<any>([]);

  const [paginationModel, setPaginationModel] =
    React.useState<GridPaginationModel>({ page: 0, pageSize: 50 });
  const [loggedInUser, setLoggedInUser] = useState("");

  let printRef = useRef();

  const handlePrint = useReactToPrint({ documentTitle: "" }) as (
    content: () => HTMLElement | null
  ) => () => void;

  useEffect(() => {
    const { username } = getCurrentUser();
    setLoggedInUser(username);
  }, []);
  //
  const onClose = () => {
    if (resetFormRef.current) {
      resetFormRef.current(); // Reset the form to its initial state
    }
    setProfileDialogOpen(false);
    setIsEditing(false);
  };

  const onCloseAddStudent = () => {
    if (resetAddStudentFormRef.current) {
      resetAddStudentFormRef.current(); // Reset the form to its initial state
    }
    setProfileDialogAddStudentOpen(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const applications_records = await ListApplication();

        if (
          applications_records &&
          applications_records.result.documents?.length > 0
        ) {
          const _string = applications_records.result.documents;
          const _json_parsed = JSONParseObject(_string);

          setApplications(_json_parsed);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        snackbarRef.current?.showSnackbar(`Error fetching data`, "error");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const JSONParseObject = (_string: any) => {
    try {
      const _json_parsed = _string.map((stud: any) => ({
        ...stud,
        transport_details: JSON.parse(stud.transport_details),
        personal_details: JSON.parse(stud.personal_details),
        guardian_details: JSON.parse(stud.guardian_details),
        father_details: JSON.parse(stud.father_details),
        mother_details: JSON.parse(stud.mother_details),
        previous_school: JSON.parse(stud.previous_school),
      }));

      return _json_parsed;
    } catch (error) {
      console.log("Error JSON parsing application object");
      console.log(error);
      return [];
    }
  };

  const updateData = (data: any, updatedRecord: any) => {
    return data.map((record: any) => {
      return record.student_id === updatedRecord.student_id
        ? updatedRecord
        : record;
    });
  };

  // const CreatePerformaceObj = (examsList: any, exam_schedules: any) => {
  //   try {
  //     const performance = {};

  //     // Iterate over each exam
  //     examsList.forEach((exam: any) => {
  //       const {
  //         session,
  //         exam_id,
  //         name,
  //         max_marks,
  //         pass_marks,
  //         total_working_days,
  //       } = exam;

  //       // Initialize the session if not present
  //       //@ts-ignore
  //       if (!performance[session]) {
  //         //@ts-ignore
  //         performance[session] = { exams: {} };
  //       }

  //       // Find the corresponding exam schedule
  //       const schedule = exam_schedules.find(
  //         (sched: any) => sched.exam_id === exam_id
  //       );

  //       // Extract subjects from the schedule
  //       let marks_details = [];
  //       let totalMarks = 0;
  //       let totalPassMarks = 0;

  //       if (schedule) {
  //         const subjects = JSON.parse(schedule.exam_schedule);
  //         marks_details = subjects.map((subject: any) => {
  //           totalMarks += Number(max_marks); // Accumulate max marks
  //           totalPassMarks += Number(pass_marks); // Accumulate pass marks

  //           return {
  //             subject_name: subject.subject,
  //             marks_obtained: 0, // Default value
  //             subject_max_marks: Number(max_marks),
  //             subject_pass_marks: Number(pass_marks),
  //           };
  //         });
  //       }

  //       // Populate exam details
  //       //@ts-ignore
  //       performance[session].exams[exam_id] = {
  //         exam_name: name,
  //         max_marks: totalMarks, // Sum of all subjects' max marks
  //         pass_marks: totalPassMarks, // Sum of all subjects' pass marks
  //         total_marks_obtained: 0, // Will be sum of marks_obtained for all subjects
  //         total_working_days: total_working_days,
  //         total_days_present: 0, // Default value
  //         marks_details,
  //       };
  //     });

  //     return performance;
  //   } catch (error) {
  //     console.log("Error getting Performance object");
  //     console.log(error);
  //     return {};
  //   }
  // };

  const JSONParseStudentObject = (student_string: any) => {
    try {
      const student_json_parsed = student_string.map((stud: any) => ({
        ...stud,
        transport_details: JSON.parse(stud.transport_details),
        personal_details: JSON.parse(stud.personal_details),
        guardian_details: JSON.parse(stud.guardian_details),
        father_details: JSON.parse(stud.father_details),
        mother_details: JSON.parse(stud.mother_details),
        previous_school: JSON.parse(stud.previous_school),
      }));

      return student_json_parsed;
    } catch (error) {
      console.log("Error JSON parsing student object");
      console.log(error);
      return [];
    }
  };

  const handleSaveProfile = async (data: any) => {
    try {
      if (data) {
        setAdding(true);
        console.log("Student data received to be added to DB");
        console.log(data);
        if (addNewStudent) {
          console.log("New Registration");
          let upload;
          let photoUrl;
          if (data.photofile) {
            const uploadFileObject: UploadFileType = {
              filepath: data.photofile!,
              bucket_id:
                process.env.REACT_APP_APPWRITE_NEW_ADMISSION_BUCKET_ID!,
            };
            upload = await uploadFile(uploadFileObject);
            console.log("Photo uploaded.");
            photoUrl = upload?.$id || "";
          }

          console.log(photoUrl);
          const { photofile, ...otherFields } = data;
          const new_application_item = {
            ...otherFields,
            roll_number: 0,
            photoUrl: photoUrl,
            academic_year: currentSessionAY, //GetCurrentAcademciSession(),
            transport_details: JSON.stringify(data.transport_details),
            personal_details: JSON.stringify(data.personal_details),
            guardian_details: JSON.stringify(data.guardian_details),
            father_details: JSON.stringify(data.father_details),
            mother_details: JSON.stringify(data.mother_details),
            previous_school: JSON.stringify(data.previous_school),
            user: loggedInUser || DEFAULT_LOGGED_USER,
          };
          console.log("New Application to be saved in DB");
          console.log(new_application_item);

          const payload = {
            newApplication: new_application_item,
          };

          const addNewItem = await AddApplication(payload);
          if (addNewItem && addNewItem.result) {
            console.log("New Application saved in DB");
            const jsonParsed = JSONParseObject([addNewItem.result]);
            setApplications([...applications, jsonParsed[0]]);
            snackbarRef.current?.showSnackbar(
              `Application Submission Successfull`,
              "success"
            );
          } else {
            snackbarRef.current?.showSnackbar(
              `Application Submission Fail`,
              "error"
            );
          }
        } else {
          console.log("Update Registration");
          let updated_registration = {};
          let photoUrl_new;
          //Update Photo if needed
          if (data.photofile) {
            console.log("New Photo added");
            const photoUrl_old = data.photoUrl;
            const uploadFileObject: UploadFileType = {
              filepath: data.photofile!,
              bucket_id:
                process.env.REACT_APP_APPWRITE_NEW_ADMISSION_BUCKET_ID!,
            };
            const upload = await uploadFile(uploadFileObject);

            console.log("Photo uploaded.");

            photoUrl_new = upload?.$id || "";
            try {
              const delete_photoUrl = await deleteFile(
                process.env.REACT_APP_APPWRITE_NEW_ADMISSION_BUCKET_ID!,
                photoUrl_old
              );
              if (delete_photoUrl)
                console.log("PhotoUrl has been removed from DB", photoUrl_old);
            } catch (error) {
              console.log("Error while deleting old photoUrl");
            }

            const { photofile, ...otherFields } = data;

            updated_registration = {
              ...otherFields,
              id: data.student_id,
              photoUrl: photoUrl_new, //Updated photoUrl for updated photo
              transport_details: JSON.stringify(data.transport_details),
              personal_details: JSON.stringify(data.personal_details),
              guardian_details: JSON.stringify(data.guardian_details),
              father_details: JSON.stringify(data.father_details),
              mother_details: JSON.stringify(data.mother_details),
              previous_school: JSON.stringify(data.previous_school),
              user: loggedInUser || DEFAULT_LOGGED_USER,
            };
          } else {
            updated_registration = {
              ...data,
              id: data.student_id,
              transport_details: JSON.stringify(data.transport_details),
              personal_details: JSON.stringify(data.personal_details),
              guardian_details: JSON.stringify(data.guardian_details),
              father_details: JSON.stringify(data.father_details),
              mother_details: JSON.stringify(data.mother_details),
              previous_school: JSON.stringify(data.previous_school),
              user: loggedInUser || DEFAULT_LOGGED_USER,
            };
          }

          const {
            //@ts-ignore
            $collectionId,
            //@ts-ignore
            $createdAt,
            //@ts-ignore
            $databaseId,
            //@ts-ignore
            $id,
            //@ts-ignore
            $permissions,
            //@ts-ignore
            $updatedAt,

            ...others
          } = updated_registration;

          const payload = {
            updatedApplication: others,
          };
          // console.log(payload);
          const updateItem = await UpdateApplication(payload);
          if (updateItem && updateItem.result) {
            const response_message = updateItem.message;
            setApplications(
              updateData(applications, {
                ...data,
                photoUrl: photoUrl_new || data.photoUrl,
              })
            );
            snackbarRef.current?.showSnackbar(`${response_message}`, "success");
          } else {
            snackbarRef.current?.showSnackbar(`Item not updated`, "error");
          }
        }
      } else {
        console.log("New Application data not received from modal");
        snackbarRef.current?.showSnackbar(`Technical Error`, "error");
      }
    } catch (error) {
      snackbarRef.current?.showSnackbar(`Error While Saving Record`, "error");
    } finally {
      setAdding(false);
    }
  };

  const handleAddStudent = async (data: any) => {
    try {
      if (data) {
        setAdding(true);
        console.log(
          "New Admission Data Received",
          JSON.stringify(data, null, 2)
        );
        const current_academic_year = currentSessionAY; //GetCurrentAcademciSession();

        //--------------- START -----------------
        //COMMENTED AS performance WILL BE UPDATED ONLY WHILE ENTERING MARKS UNDER REPORT CARD SECTION
        //HENCE HERE IT ONLY BE INITIALISED WITH DEFAULT VALUE

        // let academic_records_obj = {};
        // //Check if exams already scheduled
        // const payload = {
        //   class_id: data.class_id,
        //   academic_year: current_academic_year,
        // };
        // const exam_schedules = await GetSchedulesForClass(payload);

        // console.log("examSchedules");
        // console.log(exam_schedules);
        // if (exam_schedules && exam_schedules.result.documents.length > 0) {
        //   console.log("exam already scheduled");
        //   const examsList = await GetExams();

        //   const examRecords_filtered = examsList.result.documents.filter(
        //     (exam: any) =>
        //       exam.exam_id === exam_schedules.result.documents[0].exam_id
        //   );
        //   const performance = CreatePerformaceObj(
        //     examRecords_filtered,
        //     exam_schedules.result.documents
        //   );

        //   console.log("Performace Object created");
        //   console.log(performance);
        //   const _id = uuid();
        //   academic_records_obj = {
        //     id: _id,
        //     academic_record_id: _id,
        //     student_id: data.student_id,
        //     name: data.personal_details.name,
        //     dob: data.personal_details.dob,
        //     admission_id: data.admission_id,
        //     photoUrl: data.photoUrl,
        //     father_name: data.father_details?.name || "NA",
        //     mother_name: data.mother_details?.name || "NA",
        //     contact:
        //       data.father_details?.contact ||
        //       data.mother_details?.contact ||
        //       data.guardian_details?.contact ||
        //       "",
        //     academic_year: current_academic_year,
        //     anual_outcome: "",
        //     class_id: data.class_id,
        //     class_name: data.class_name,
        //     section_id: data.section_id,
        //     section: data.section_name,
        //     roll_number: parseInt(data.roll_number),
        //     // performance: JSON.stringify(performance),
        //     performance: JSON.stringify({
        //       term1: {
        //         exams: {},
        //       },
        //       term2: {
        //         exams: {},
        //       },
        //     }),
        //     user: loggedInUser || DEFAULT_LOGGED_USER,
        //   };
        // } else {
        //   //If Not scheduled then create standard academic_record
        //   console.log("exam not scheduled");
        //   const _id = uuid();
        //   academic_records_obj = {
        //     id: _id,
        //     academic_record_id: _id,
        //     student_id: data.student_id,
        //     name: data.personal_details.name,
        //     dob: data.personal_details.dob,
        //     admission_id: data.admission_id,
        //     photoUrl: data.photoUrl,
        //     father_name: data.father_details?.name || "NA",
        //     mother_name: data.mother_details?.name || "NA",
        //     contact:
        //       data.father_details?.contact ||
        //       data.mother_details?.contact ||
        //       data.guardian_details?.contact ||
        //       "",
        //     academic_year: current_academic_year,
        //     anual_outcome: "",
        //     class_id: data.class_id,
        //     class_name: data.class_name,
        //     section_id: data.section_id,
        //     section: data.section_name,
        //     roll_number: parseInt(data.roll_number),
        //     user: loggedInUser || DEFAULT_LOGGED_USER,
        //     performance: JSON.stringify({
        //       term1: {
        //         exams: {},
        //       },
        //       term2: {
        //         exams: {},
        //       },
        //     }),
        //   };
        // }

        // --------------- END -------------------

        const _id = uuid();
        const academic_records_obj = {
          id: _id,
          academic_record_id: _id,
          student_id: data.student_id,
          name: data.personal_details.name,
          dob: data.personal_details.dob,
          admission_id: data.admission_id,
          photoUrl: data.photoUrl,
          father_name: data.father_details?.name || "NA",
          mother_name: data.mother_details?.name || "NA",
          contact:
            data.father_details?.contact ||
            data.mother_details?.contact ||
            data.guardian_details?.contact ||
            "",
          academic_year: current_academic_year,
          anual_outcome: "",
          class_id: data.class_id,
          class_name: data.class_name,
          section_id: data.section_id,
          section: data.section_name,
          roll_number: parseInt(data.roll_number),
          user: loggedInUser || DEFAULT_LOGGED_USER,
          performance: JSON.stringify({
            term1: {
              exams: {},
            },
            term2: {
              exams: {},
            },
          }),
        };

        console.log("academic_records_obj Object created");
        console.log(academic_records_obj);

        let photoUrl_new;
        //CHECK IF PHOTO IS RE-UPLOADED
        if (data.photofile) {
          console.log("New Photo added");
          const photoUrl_old = data.photoUrl;
          const uploadFileObject: UploadFileType = {
            filepath: data.photofile!,
            bucket_id: process.env.REACT_APP_APPWRITE_NEW_ADMISSION_BUCKET_ID!,
          };
          const upload = await uploadFile(uploadFileObject);

          console.log("Photo uploaded.");

          photoUrl_new = upload?.$id || "";
          try {
            const delete_photoUrl = await deleteFile(
              process.env.REACT_APP_APPWRITE_NEW_ADMISSION_BUCKET_ID!,
              photoUrl_old
            );
            if (delete_photoUrl)
              console.log("PhotoUrl has been removed from DB", photoUrl_old);
          } catch (error) {
            console.log("Error while deleting old photoUrl");
          }

          data = {
            ...data,
            photoUrl: photoUrl_new,
          };
        }

        const student_item = {
          ...data,
          academic_year: currentSessionAY,
          roll_number: parseInt(data.roll_number),
          transport_details: JSON.stringify(data.transport_details),
          personal_details: JSON.stringify(data.personal_details),
          guardian_details: JSON.stringify(data.guardian_details),
          father_details: JSON.stringify(data.father_details),
          mother_details: JSON.stringify(data.mother_details),
          previous_school: JSON.stringify(data.previous_school),
          user: loggedInUser || DEFAULT_LOGGED_USER,
        };
        console.log("Student to be saved in DB");
        console.log(student_item);

        const addNewItem = await AddStudent(student_item);
        if (addNewItem && addNewItem.result) {
          console.log("Student saved in DB");
          snackbarRef.current?.showSnackbar(
            `Student Admission Success. Updating Academic Records`,
            "success"
          );
          const addNewItem_acad_record = await AddAcademicsRecord(
            academic_records_obj
          );
          if (addNewItem_acad_record && addNewItem_acad_record.result) {
            console.log("Academic record saved in DB");
            snackbarRef.current?.showSnackbar(
              `Student Academic Records Updated. Updating Application Status `,
              "success"
            );
            const payload = {
              updatedApplication: {
                id: student_item.student_id,
                application_status: "Completed",
                admission_id: student_item.admission_id,
                user: loggedInUser || DEFAULT_LOGGED_USER,
              },
            };
            const updatedFormStatus = await UpdateApplication(payload);
            if (updatedFormStatus && updatedFormStatus.result) {
              setApplications((prevItem: any) =>
                prevItem.map((item: any) =>
                  item.student_id === student_item.student_id
                    ? {
                        ...item,
                        application_status: "Completed",
                        admission_id: student_item.admission_id,
                      }
                    : item
                )
              );
              snackbarRef.current?.showSnackbar(
                `Application Status Updated`,
                "success"
              );
            }
          } else {
            snackbarRef.current?.showSnackbar(
              `Academic Record Creation Failed.`,
              "error"
            );
          }
        } else {
          snackbarRef.current?.showSnackbar(`Student Not Added`, "error");
        }
      }
    } catch (error) {
    } finally {
      setAdding(false);
    }
  };

  const handleViewClick = useCallback(async (rowData: any) => {
    console.log("Row Data");
    console.log(rowData);

    setIsEditing(true);
    setProfileDialogOpen(true);
    setAddNewStudent(false);
    setSelectedRow(rowData);

    // Slightly defer setting selectedRow to prevent blocking UI rendering
    // setTimeout(() => {
    //   // setSelectedRow(rowData);
    //   setSelectedRow(student_full_Data);
    //   console.log("Row Data:", student_full_Data);
    // }, 0); // Delay execution until the next event loop cycle
  }, []);

  const handlePrintClick = useCallback(async (rowData: any) => {
    console.log("Row Data");
    console.log(rowData);
    setPrintStart(true);
    setPrintData(rowData);

    setTimeout(() => {
      try {
        handlePrint(() => printRef.current!)();
        setPrintStart(false);
      } catch (error) {
        console.log("Handling print function call error.");
        console.log(error);
        setPrintStart(false);
      }
    }, 400);

    // try {
    //   handlePrint(() => printRef.current!)();
    // } catch (error) {
    //   console.log("Handling print function call error.");
    //   console.log(error);
    // }
  }, []);

  const handleVerifyAndAddStudent = useCallback(async (rowData: any) => {
    console.log("Row Data");
    console.log(rowData);

    // setIsEditing(true);
    setProfileDialogAddStudentOpen(true);
    // setAddNewStudent(false);
    setSelectedRow(rowData);
  }, []);

  const handleAddNewStudent = () => {
    console.log("Add New Student Clicked");
    setProfileDialogOpen(true);
    setAddNewStudent(true);
  };

  // Define columns with DataGrid
  const columns: GridColDef[] = [
    {
      field: "admission_id",
      headerName: "Adm. ID",
      flex: 0.5,
      valueGetter: (_, row) => {
        return row.admission_id.toString().padStart(5, "0");
      },
    },
    {
      field: "personal_details",
      headerName: "Name",
      flex: 1,
      valueGetter: (_, row) => row.personal_details.name,
    },
    {
      field: "parent_details",
      headerName: "Father's Name",
      flex: 1,
      valueGetter: (_, row) => row.father_details.name,
    },
    {
      field: "mother_details",
      headerName: "Mother's Name",
      flex: 1,
      valueGetter: (_, row) => row.mother_details.name,
    },
    {
      field: "class_name",
      headerName: "Adm. Class",
      flex: 0.8,
      valueGetter: (_, row) => row.class_name,
    },

    {
      field: "parent_contact",
      headerName: "Contact",
      flex: 0.8,
      valueGetter: (_, row) =>
        row.father_details.contact ||
        row.mother_details.contact ||
        row.guardian_details.contact ||
        "N/A",
    },
    {
      field: "application_status",
      headerName: "Status",
      flex: 0.8,
      valueGetter: (_, row) => {
        return row.application_status;
      },
      renderCell: (params) => {
        // const isPaid = params.value === "Paid"; // Use precomputed value

        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "row",
              gap: 1,
              backgroundColor:
                params.value === "Completed" ? "#00c9a6" : "#FDCDBE",
              borderRadius: 4,
              padding: "4px 8px",
              marginTop: 0.6,
            }}
          >
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                backgroundColor:
                  params.value === "Completed" ? "green" : "#FF825B",
              }}
            />
            <Typography variant="body2">
              {params.value === "Completed" ? "Completed" : params.value}
            </Typography>
          </Box>
        );
      },
    },
    // {
    //   field: "admission_fee",
    //   headerName: "Adm. Fee",
    //   flex: 1,
    //   valueGetter: (_, row) => row.admission_fee,
    // },
    {
      field: "actions",
      headerName: "Actions",
      flex: 2,
      headerAlign: "center",
      align: "center",
      valueGetter: (_, row) => {
        return row.application_status;
      },
      renderCell: (params) => (
        <>
          {printStart ? (
            <CircularProgress size={20} style={{ padding: 2 }} />
          ) : (
            <AnimatedButton
              label="Print"
              onClick={() => {
                handlePrintClick(params.row);
              }}
              disabled={false}
            />
          )}
          {"|"}
          {hasPermission("New Admission Form") && (
            <AnimatedButton
              label="View Application"
              onClick={() => {
                handleViewClick(params.row);
              }}
              disabled={false}
            />
          )}
          {hasPermission("New Admission Form") && "|"}
          {hasPermission("New Admission") && (
            <AnimatedButton
              label="Take Admission"
              onClick={() => {
                handleVerifyAndAddStudent(params.row);
              }}
              disabled={params.value === "Completed"}
            />
          )}
          {/* {"|"}
          <AnimatedButton
            label="Take Admission"
            onClick={() => console.log("Take Admission")}
            disabled={false}
          /> */}
          {/* {"|"}
          <AnimatedButton
            label="Character"
            onClick={() => console.log("Get TC Clicked")}
            disabled={false}
          /> */}
          {/* {"|"}
          <AnimatedButton
            label="DeActivate"
            onClick={() => console.log("Disabled Clicked")}
            disabled={false}
          /> */}
        </>
      ),
    },
  ];

  return (
    <>
      <ToastSnackbar ref={snackbarRef} />

      {printData && (
        <div style={{ display: "none" }}>
          {/*@ts-ignore */}
          <AdmissionForm ref={printRef} feesData={printData} />
        </div>
      )}

      <Box
        display={"flex"}
        flexDirection={"column"}
        p={2}
        height="auto"
        // style={{ minHeight: "100vh" }}
      >
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
        >
          <Box
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"flex-start"}
            p={2}
            pb={0}
            gap={1}
          >
            <MyCustomButton
              variant="contained"
              startIcon={<ArrowLeftIcon />}
              onClick={() => navigate("..")}
            >
              Go Back
            </MyCustomButton>
            <MyCustomButton
              variant="contained"
              startIcon={<HomeIcon />}
              onClick={() => navigate("/home")}
            >
              Home
            </MyCustomButton>
          </Box>
          {hasPermission("New Admission Form") && (
            <MyCustomButton
              variant="contained"
              startIcon={adding ? <CircularProgress /> : <PersonAddIcon />}
              onClick={handleAddNewStudent}
              disabled={adding}
            >
              {adding ? "...WAIT" : "NEW ADMISSION FORM"}
            </MyCustomButton>
          )}
        </Box>

        <Typography variant="h5" alignSelf={"center"} mb={-2}>
          <strong>New Admission Home</strong>
        </Typography>

        {/**This is Datagrid */}
        <Grid container direction="column" mt={4}>
          <Grid item xs={12}>
            <DataGrid
              rows={applications}
              columns={columns}
              rowHeight={40}
              getRowId={(row) => row.student_id}
              pageSizeOptions={[50, 100]}
              loading={loading}
              rowBufferPx={300} // Loads extra rows for smoother scrolling
              disableColumnFilter // Improves performance
              disableColumnMenu // Removes menu for better speed
              disableRowSelectionOnClick // Prevents unnecessary re-renders
              slots={{
                toolbar: GridToolbar,
                noRowsOverlay: () => <CustomNoRowsOverlay loading={loading} />,
              }}
              slotProps={{ toolbar: { showQuickFilter: true } }}
              sx={{
                maxWidth: "98vw",
                height: "65vh", // Fixed height for the grid
                // Target the column headers specifically

                "& .MuiDataGrid-row:hover": {
                  transform: "scale(1)", // Hover zoom effect
                  backgroundColor: "#f5f5f5", // Light background on hover
                  "& .MuiDataGrid-cell": {
                    color: "#2E186A", // Change text color on hover
                    fontWeight: "bold", // Bold text on hover
                  },
                },
                "& .MuiDataGrid-row.Mui-selected": {
                  backgroundColor: "#f0f0f0", // Active row background color
                },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#1e88e5", // Custom background color for header
                  // fontFamily: "Motiva Sans Bold",
                  color: "#2e186a", // Custom text color for header
                  fontSize: "1rem", // Increase font size of header
                  borderBottom: "2px solid #fff", // Add a border at the bottom of headers
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  textOverflow: "clip", // Prevent ellipsis from appearing
                  whiteSpace: "normal", // Ensure text wraps if it's too long
                  lineHeight: "1", // Adjust line height
                },
                "& .MuiDataGrid-columnHeader": {
                  padding: "0px 10px", // Add padding to header cells
                },
              }}
            />
          </Grid>
        </Grid>
      </Box>

      {isProfileDialogOpen && (
        <NewAdmissionFormDialog
          isOpen={isProfileDialogOpen}
          onClose={onClose}
          onSubmit={handleSaveProfile}
          profileData={addNewStudent ? new_admission_template[0] : selectedRow}
          resetFormRef={resetFormRef}
          isEditing={
            addNewStudent
              ? true
              : selectedRow.application_status === "Completed"
              ? false
              : isEditing
          }
          onEdit={() => setIsEditing(true)}
          addSibling={addNewStudent}
        />
      )}

      {isProfileDialogAddStudentOpen && (
        <NewStudentAdmissionDialog
          isOpen={isProfileDialogAddStudentOpen}
          onClose={onCloseAddStudent}
          onSubmit={handleAddStudent}
          // profileData={addNewStudent ? students_empty[0] : selectedRow}
          profileData={{
            ...selectedRow,
            academic_records: [
              {
                class_id: selectedRow.class_id,
                section_id: selectedRow.section_id,
                roll_number: selectedRow.roll_number,
                academic_year: currentSessionAY, //GetCurrentAcademciSession(),
              },
            ],
          }}
          resetFormRef={resetAddStudentFormRef}
          isEditing={true}
          onEdit={() => setIsEditingAddStudent(true)}
          addSibling={false}
        />
      )}
    </>
  );
};

export default React.memo(NewAdmission);
